import { Failure } from "@pdfking/errors"
import type { Validator } from "@pdfking/forms"
import type { ComponentFailure } from "@pdfking/imposition/internal"
import type { ImpositionSchema } from "@pdfking/imposition/internal"
import { ApplyComponentFailures } from "@pdfking/imposition/internal"

/**
 * Mirrors Python `_get_imposition_data` (`packing/presets/concrete.py:195-210`):
 * the last job in a component must produce output, i.e. print front and/or
 * rear. Fails the last job's `print_mode` with `REQUIRED_ERROR`.
 */
export const ValidateLastJobPrints: Validator<ImpositionSchema> = results => {
  if (results.component_array.error) return results

  const failures: ComponentFailure[] = []

  const components = results.component_array.value ?? []
  components.forEach(({ job_array }, ci) => {
    const last = job_array.length - 1
    if (last < 0) return

    const { is_front, is_rear } = job_array[last]!.print_mode
    if (!is_front && !is_rear) {
      failures.push({
        path: [ci, "job_array", last, "print_mode"],
        error: Failure("REQUIRED_ERROR", { input: undefined }),
      })
    }
  })

  return ApplyComponentFailures(results, failures)
}
